/**
 * O que a tela de estoque DIZ — fora do componente, onde um teste alcança. A
 * conta do saldo é do banco (view `estoq.saldo`); aqui só se conta a faixa e se
 * nomeia.
 */
import type { SaldoDaApi } from './api';

export const ROTULO_DA_CATEGORIA: Readonly<Record<string, string>> = {
  peca: 'Peça',
  filtro: 'Filtro',
  pneu: 'Pneu',
  insumo: 'Insumo',
  lubrificante: 'Lubrificante',
  combustivel: 'Combustível',
  arla: 'ARLA',
  outro: 'Outro',
};

export interface ContagemDoEstoque {
  readonly abaixoDoMinimo: number;
  readonly criticosAbaixo: number;
  readonly comReserva: number;
  readonly locais: number;
}

/**
 * A faixa do topo. Abaixo do mínimo conta POSIÇÕES (item × depósito): o mesmo
 * filtro pode faltar num depósito e sobrar no outro, e a reposição é por
 * depósito.
 */
export function contarEstoque(saldos: readonly SaldoDaApi[]): ContagemDoEstoque {
  return {
    abaixoDoMinimo: saldos.filter((s) => s.abaixoDoMinimo).length,
    criticosAbaixo: saldos.filter((s) => s.abaixoDoMinimo && s.critico).length,
    comReserva: saldos.filter((s) => s.reservado > 0).length,
    locais: new Set(saldos.map((s) => `${s.localTipo}:${s.localId}`)).size,
  };
}

/** A situação escrita da posição — nunca só a cor. */
export function situacaoDoSaldo(s: SaldoDaApi): string {
  if (s.fisico <= 0) return 'Sem saldo';
  if (s.disponivel <= 0) return 'Todo reservado';
  if (s.abaixoDoMinimo) return 'Abaixo do mínimo';
  return 'Em estoque';
}
